export default __webpack_public_path__ + "static/media/restaurant_bills_2.10f6fc1e.svg";